import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mortgage } from '../../dialer/model/model.mortgage';

@Component({
  selector: 'app-lead',
  templateUrl: './lead.component.html',
  styleUrls: ['./lead.component.css']
})

export class LeadComponent implements OnInit {
  name: string;
  firstdata: string;
  lastdata: string;
  status: string;
  dispo_datetime: string;
  color: string;
  @Input() data: Mortgage;
  @Output() leadclick: EventEmitter<Mortgage> = new EventEmitter();

  constructor() { }

  ngOnInit() {

    this.name = this.data.edit.first_name + " " + this.data.edit.last_name;
    if(isNaN(parseInt(this.data.edit.first_name)) && this.data.edit.first_name=="" ){
      this.firstdata = "U";
    this.lastdata = "N";
    
  }else{
    this.firstdata = this.data.edit.first_name[0];
    this.lastdata = this.data.edit.last_name[0];
  }
    
    this.status = this.data.disposition;
    this.dispo_datetime = "";
    if (this.data.disposition == "fresh")
      this.color = "greenyellow";
    if (this.data.disposition == "NC")
      this.color = "gold";
    if (this.data.disposition == "CB") {
      this.color = "yellow";
      this.dispo_datetime = this.data.dispodate;
    }
    if (this.data.disposition == "APPT" || this.data.disposition == "DK") {
      this.color = "darkseagreen";
      this.dispo_datetime = this.data.dispodate;
    }
    if (this.data.disposition == "NI")
      this.color = "salmon";
    if (this.data.disposition == "W#")
      this.color = "tomato";

  }

  onClick() {
    this.leadclick.emit(this.data);
  }
}
